import { render, staticRenderFns } from "./FarmGoodsTrace.vue?vue&type=template&id=760a2082&scoped=true&"
import script from "./FarmGoodsTrace.vue?vue&type=script&lang=js&"
export * from "./FarmGoodsTrace.vue?vue&type=script&lang=js&"
import style0 from "./FarmGoodsTrace.vue?vue&type=style&index=0&id=760a2082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a2082",
  null
  
)

export default component.exports